import themeProperties from '../../../../src/theme/themeProperties';

interface Props {
  color?: string;
}

const OceanforceChallengeIcon = ({
  color = themeProperties.light.primaryFontColor,
}: Props) => {
  return (
    <svg
      width="100%"
      viewBox="0 0 512 622"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M319.601 471.985C313.085 465.481 306.569 449.187 303.31 439.431C300.052 436.179 303.31 419.919 303.31 416.633V393.835C306.569 387.331 306.569 377.575 303.31 371.036C296.794 364.532 300.052 358.028 303.31 348.238C303.31 341.734 306.569 325.44 313.085 318.936C322.859 302.676 339.184 292.886 355.474 289.634C357.646 287.466 359.818 286.382 361.99 286.382C368.507 283.13 378.281 283.13 384.831 283.13C397.864 279.878 410.93 279.878 423.963 279.878C430.479 283.13 433.737 283.13 440.253 279.878C440.253 279.878 443.511 283.13 440.253 276.626C436.995 273.374 430.479 273.374 427.221 273.374C414.188 270.122 404.38 270.122 391.347 270.122C384.831 270.122 381.573 270.122 381.573 260.366C388.089 244.106 407.672 244.106 414.188 234.315C416.36 232.147 416.36 231.063 414.188 231.063C407.672 234.315 397.898 237.567 391.347 237.567C375.057 244.071 371.799 247.323 361.99 257.079C352.216 263.583 345.7 270.087 335.891 270.087C329.375 270.087 322.859 270.087 316.343 273.339C316.343 250.541 326.117 221.273 339.184 198.475C342.442 188.719 345.7 182.215 352.216 172.425C355.474 169.173 355.474 165.921 355.474 159.417C348.958 159.417 345.7 169.173 342.442 172.425C335.926 178.929 332.668 185.433 329.409 191.937C316.377 211.449 313.119 165.886 313.119 159.382C313.119 156.13 316.377 139.87 313.119 136.584C309.861 139.836 309.861 149.592 309.861 149.592C306.603 159.348 306.603 165.852 306.603 172.39C303.345 185.398 303.345 198.441 303.345 208.197C300.087 227.709 300.087 234.247 293.57 250.507C274.022 286.313 267.472 328.624 264.213 367.682C260.955 344.884 257.697 322.119 254.439 296.069C251.181 289.565 251.181 283.061 251.181 273.271C247.923 266.767 251.181 253.759 254.439 243.969C257.697 227.709 264.213 211.415 264.213 191.902C264.213 188.65 267.471 162.6 267.471 159.348C264.213 156.096 260.955 165.852 260.955 165.852C257.697 178.86 257.697 191.902 254.439 204.91C251.181 211.414 241.407 237.465 231.598 237.465C228.34 237.465 225.082 230.961 221.824 227.709C218.566 221.205 215.308 214.701 212.05 211.449C202.275 198.441 199.017 191.937 189.209 182.146C185.951 175.642 182.693 172.39 179.435 169.138C176.176 165.886 172.918 169.138 172.918 169.138C172.918 178.894 179.435 185.398 185.951 191.937C195.725 201.693 202.241 221.239 208.792 230.995C215.308 253.793 215.308 273.305 215.308 296.103C189.209 292.851 176.176 292.851 153.336 296.103C140.303 296.103 127.237 302.607 114.204 305.859C114.204 305.859 110.946 309.111 110.946 312.363C120.72 312.363 130.495 309.111 140.303 305.859C159.852 302.607 185.951 309.111 202.275 322.119C212.05 331.875 221.824 344.918 228.374 357.926C234.891 377.438 231.633 374.186 234.891 393.732C234.891 403.488 234.891 409.992 231.633 419.782C231.633 426.286 231.633 432.79 228.374 442.58C225.116 449.084 221.858 452.336 221.858 458.84C218.6 468.596 212.084 475.101 202.31 478.353C186.019 484.857 189.277 481.605 172.953 478.353C153.404 475.101 156.662 491.36 137.079 491.36H133.821C117.531 488.108 107.722 488.109 94.6899 494.613C84.9157 497.865 78.3995 497.865 68.5909 494.613H45.75L55.5243 497.865C65.2985 497.865 81.6233 504.369 91.3975 501.117C101.172 497.865 104.43 494.613 114.238 497.865C117.497 497.865 130.529 501.117 133.787 501.117C137.045 507.621 130.529 520.629 127.271 523.915C120.755 533.671 114.238 533.671 104.43 540.175C104.43 543.427 97.9137 549.931 97.9137 549.931C97.9137 549.931 107.688 543.427 110.946 540.175C117.462 536.923 123.978 533.671 130.495 527.167C143.527 517.411 146.785 504.369 159.852 494.613C163.11 494.613 163.11 491.36 166.368 491.36C172.884 491.36 176.142 501.117 192.467 501.117H198.983C202.241 497.865 205.499 497.865 212.015 497.865C215.273 501.117 221.79 504.368 215.273 507.62C212.015 510.872 202.241 517.377 198.983 520.629C190.295 527.133 181.595 531.469 172.884 533.637C153.336 540.141 143.527 553.149 130.495 562.939C120.72 569.443 114.204 566.191 107.654 569.443C104.396 572.695 107.654 572.695 110.912 572.695C121.772 570.527 131.558 566.191 140.269 559.687C146.785 556.435 163.11 543.427 172.884 546.679C179.4 549.931 176.142 556.435 172.884 559.687C169.626 566.191 169.626 572.695 163.11 579.199C156.594 582.451 153.336 585.703 146.819 592.207L137.045 601.963C137.045 601.963 127.271 608.467 130.529 611.719L137.045 608.467C143.561 605.215 143.561 601.963 150.077 598.711C153.336 595.459 156.594 592.207 163.11 588.955C179.4 575.947 182.658 569.443 189.209 549.897C195.725 540.141 198.983 536.889 205.499 530.385C212.015 527.133 221.79 523.881 228.34 523.881H231.598C234.856 527.133 238.114 536.889 241.372 540.141C247.889 549.897 254.405 556.401 257.663 569.443C257.663 575.947 254.405 585.703 254.405 595.493V611.753C254.405 611.753 254.405 621.509 257.663 618.257C260.921 618.257 260.921 605.249 260.921 601.997C260.921 598.745 260.921 579.199 270.695 575.947C277.211 575.947 286.986 582.451 290.244 588.955C293.502 595.459 296.76 598.711 300.018 605.215C303.276 605.215 316.309 621.475 319.567 621.475C313.05 611.719 303.276 601.963 296.726 592.173C290.175 582.382 290.21 579.165 277.177 569.374C273.919 566.122 270.661 566.122 267.403 559.618C267.403 556.366 264.145 546.61 260.887 543.358V540.106C254.371 523.846 260.887 520.594 267.403 510.804C270.661 507.552 273.919 504.3 280.435 504.3C290.21 501.048 299.984 507.552 306.534 514.056C319.567 527.064 322.825 533.568 322.825 546.61C326.083 562.87 329.341 562.87 335.857 575.913C339.115 585.669 339.115 595.425 342.373 605.215C345.631 608.467 345.631 601.963 345.631 601.963C345.631 592.207 342.373 582.451 339.115 572.661C339.115 569.409 332.599 559.653 335.857 553.149C339.115 549.897 342.373 553.149 345.631 556.401C348.889 559.653 352.148 562.905 358.664 566.157C361.922 569.409 368.438 572.661 374.954 575.913C384.728 582.417 387.986 592.173 391.245 601.963C391.245 605.215 394.503 614.971 397.761 614.971C401.019 611.719 397.761 608.467 397.761 605.215C394.503 595.459 394.503 585.703 384.728 575.913C378.212 569.409 365.18 559.653 358.629 553.114C345.597 540.106 335.788 533.602 332.53 517.308C332.53 507.552 335.788 507.552 342.305 504.3C352.079 501.048 358.595 507.552 365.146 514.056C374.92 527.064 384.694 536.854 401.019 540.106C407.535 543.358 410.793 543.358 417.309 546.61C423.825 546.61 414.051 543.358 414.051 543.358C404.277 536.854 394.503 536.854 387.952 527.098C384.694 523.846 384.694 517.342 391.21 517.342H414.051C433.6 520.594 440.15 520.594 456.441 507.586C466.215 504.334 469.473 501.082 479.282 501.082H489.056C491.228 501.082 492.314 499.998 492.314 497.83H476.023C456.475 497.83 453.183 514.09 430.376 510.838C420.602 510.838 414.085 507.586 404.277 507.586C397.761 504.334 387.986 504.334 378.178 501.082C365.146 497.83 365.146 491.326 355.337 488.074C345.563 481.57 335.788 488.074 329.238 481.57L319.464 471.814L319.601 471.985Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M221.76 87.8724C198.919 100.88 195.661 136.687 215.244 156.233C241.343 139.973 241.343 104.167 221.76 87.8724Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M273.951 74.8646C247.852 81.3686 231.561 113.923 244.594 136.721C273.951 130.217 286.983 100.915 273.951 74.8646Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M313.082 100.915C283.725 100.915 264.177 126.965 267.435 156.267C296.792 156.267 319.599 130.217 313.082 100.915Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166.333 172.527C156.559 146.477 127.202 133.469 101.103 146.477C110.877 175.779 140.234 185.535 166.333 172.527Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M254.37 13.0079C231.53 26.0159 225.013 58.5702 241.338 78.1164C267.437 68.3604 273.953 32.5542 254.37 13.0079Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M172.846 91.1587C150.005 110.671 153.298 143.225 179.363 159.519C198.911 140.007 195.653 104.167 172.846 91.1587Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M446.809 286.45C446.809 315.752 472.908 335.264 498.973 328.76C498.973 302.71 472.874 279.946 446.809 286.45Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M440.256 175.779C433.739 149.729 453.288 123.713 482.645 123.713C489.161 149.763 469.613 175.779 440.256 175.779Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M381.575 104.167C384.833 133.469 362.026 156.233 332.669 152.981C332.669 123.679 355.51 100.915 381.575 104.167Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M352.219 48.814C368.509 71.6123 358.735 104.167 332.67 113.923C316.38 91.1243 326.154 58.57 352.219 48.814Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M427.222 130.217C420.706 156.267 391.349 172.527 365.25 162.771C371.766 133.469 401.123 117.209 427.222 130.217Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M150.013 136.721C156.529 107.419 136.98 81.3687 107.623 81.3687C101.107 107.419 120.656 136.721 150.013 136.721Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M283.726 22.7984C270.694 45.5966 286.984 78.1509 313.083 84.6549C326.115 58.6047 313.083 29.3024 283.726 22.7984Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M394.607 286.45C391.349 315.752 417.448 338.516 446.771 332.012C446.771 305.962 420.671 283.198 394.607 286.45Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M512.008 240.887C508.75 266.938 476.135 283.198 453.294 273.442C456.552 247.391 485.909 231.131 512.008 240.887Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.206 166.023C228.305 159.519 251.112 179.032 251.112 205.082C228.271 211.586 202.206 192.074 202.206 166.023Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M472.868 195.326C446.769 198.578 427.22 224.628 436.995 250.678C463.094 250.678 482.642 221.376 472.868 195.326Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M420.705 159.485C443.546 175.745 440.253 211.551 417.447 227.845C397.898 208.333 397.898 175.779 420.705 159.485Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M332.632 224.593C355.473 240.853 388.088 231.097 397.863 205.081C375.022 188.821 342.407 198.577 332.632 224.593Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.6177 322.256C55.4586 341.768 88.0738 335.264 101.106 312.5C81.5576 292.988 48.9424 296.24 32.6177 322.256Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.716 292.954C123.941 266.904 91.3262 253.896 68.4853 270.156C75.0015 296.206 107.617 309.214 133.716 292.954Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.5825 367.819C120.681 371.071 146.746 345.02 143.488 319.004C114.131 315.752 91.3244 338.516 94.5825 367.819Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M185.878 205.082C166.33 185.57 133.714 185.57 117.39 208.334C133.68 231.132 169.553 227.846 185.878 205.082Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M185.877 273.442C176.103 244.14 146.746 234.384 120.647 247.392C130.421 273.442 163.036 286.45 185.877 273.442Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.7133 192.039C78.2618 211.551 110.877 208.299 127.202 185.535C107.653 166.023 71.7456 169.275 58.7133 192.039Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.619 247.392C101.103 221.342 68.488 208.334 45.647 221.342C52.1632 247.392 84.7784 260.4 107.619 247.392Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.207 94.4106C208.724 68.3604 185.917 42.3444 156.56 42.3444C153.302 68.3946 172.85 94.4106 202.207 94.4106Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M391.344 120.427C384.828 94.3763 404.376 65.0741 433.733 65.0741C440.249 94.3763 420.701 120.427 391.344 120.427Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 266.904C19.5485 286.416 52.1637 283.164 68.4884 257.148C48.9399 237.636 13.0324 244.14 0 266.904Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.142 136.721C104.368 110.671 75.0107 97.6626 48.9117 110.671C58.686 136.721 88.0431 149.729 114.142 136.721Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.207 0.00012207C228.306 13.0081 238.08 45.5624 218.497 65.1086C192.398 55.3526 185.882 22.7984 202.207 0.00012207Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159.816 81.3685C159.816 55.3182 130.459 35.8062 104.36 42.3102C104.36 71.6125 133.717 91.1245 159.816 81.3685Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M407.677 32.5539C381.578 32.5539 362.029 61.8561 371.803 87.9064C397.902 84.6544 417.451 58.6041 407.677 32.5539Z"
        fill={color}
      />
    </svg>
  );
};

export default OceanforceChallengeIcon;
